export default class IssuesList {
    issues = []

    add(issue) {
        this.issues.push(issue)
    }

    /**
     * Returns all issues from specified step.
     *
     * @param {*} step
     * @return {Array}
     */
    getByStep(step) {
        return this.issues.filter(x => x.getStep() === step)
    }

    /**
     * Categorizes all issues into lists by their step.
     * @return {Array}
     */
    getCategorizedByStep() {
        let result = []

        this.issues.forEach(issue => {
            let step = issue.getStep()
            let found = false

            // Add it to already existing list if one can be found...
            result.forEach(list => {
                if (list.step === step) {
                    list.items.push(issue)
                    found = true
                }
            })

            // ... if not - create a new list with current issue as the first one.
            if (!found) {
                result.push({
                    step: step,
                    items: [issue]
                })
            }
        })

        return result
    }

    getAll() {
        return this.issues
    }
}